export default __webpack_public_path__ + "slices/main/assets/public/media/lattice-logo.6b6c683120efb94409f701c77122d3c5.png";